
















import { Vue, Component } from 'vue-property-decorator';
import router from '../router';
import { MedTransGoConstants } from '../util/constants';
import DataTable from '../components/DataTable.vue';
import { ObjectFactory } from '@/config/objectFactory';
import { DateUtils } from '@/util/dateUtils';
import { CommonUtils } from '@/util/commonUtils';
import { MemberProfile } from '@/types/response';
import { AccessKey } from '@/types/entity';
import { ApiRequest } from '@/types/request';
import { EventBus } from '@/main';
import { ToastEvent } from '@/types/event';

// tslint:disable-next-line: no-var-requires
const ApiKeyTable = require('../datatable/APIKeyTable.json');
@Component({
    methods: {
        goBack() {
            router.back();
        },
    },
    components: {
        DataTable,
    },
    watch: {
        $route(to, from) {
            if (!to.path.endsWith(MedTransGoConstants.URL_ADD_ACCESS_KEY)) {
                const accessKeyListComponent = this as AccessKeyList;
                accessKeyListComponent.getAccessKeyList();
            }
        },
    },
    data() {
        return {
            header: 'API Integration',
            options: [
                {
                    url: 'access-keys',
                    activeConditions: {
                        lastletters: 'access-keys',
                    },
                    label: 'Access Key',
                },
            ],
        };
    },
})
export default class AccessKeyList extends Vue {
    private apiKeyTableDataSource = ApiKeyTable;
    private showLimiEexceeded = false;
    private accessKeys: AccessKey[] = [];

    public async mounted() {
        this.getAccessKeyList();
    }

    private showAddAPIKeys() {
        if (this.accessKeys && this.accessKeys.length > 0) {
            this.showLimiEexceeded = true;
        } else {
            this.$router.push({ path: MedTransGoConstants.URL_ADD_ACCESS_KEY, append: true });
        }
    }
    private async getAccessKeyList(searchString?: string, start?: number) {
        const response = await ObjectFactory.getMemberService().getAccessKeyList(this.$store.state.serverUrl, start);
        if (response.success && response.data) {
            response.data.forEach((accessKey) => {
                accessKey.createdOn = DateUtils.formatDate(accessKey.createdOn) as any;
                accessKey.expiresAt = DateUtils.formatDate(accessKey.expiresAt) as any;
            });
            this.accessKeys = response.data;
            this.apiKeyTableDataSource.data = response.data;
            if (response.totalCount) {
                this.apiKeyTableDataSource.totalCount = response.totalCount;
            } else {
                CommonUtils.showError(response);
            }
        }
    }

    private async deleteAccessKey(accessKey: any) {
        const apiRequest: ApiRequest = {
            baseURL: this.$store.state.serverUrl,
            url: `${MedTransGoConstants.HTTP_URL_ACCESS_KEYS}/${accessKey.id}`,
            loaderEvent: {
                show: true,
            },
        };
        const response = await ObjectFactory.getHttpService().delete<any>(apiRequest);
        if (response.success) {
            const toastEvent: ToastEvent = {
                message: 'Access Key has been deleted',
                title: 'Success',
                varient: 'success',
                timeout: 2000,
            };
            EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, toastEvent);
            this.getAccessKeyList();
        } else {
            CommonUtils.showError(response);
        }
    }
}
